import { IonCol, IonIcon, IonInput, IonRow } from '@ionic/react';
import { useState } from 'react';
import { eye, eyeOff } from 'ionicons/icons';
import { AutocompleteTypes } from '@ionic/core/dist/types/interface';

const PasswordInput: React.FC<{
    value: string;
    ariaLabel?: string;
    onchange: React.ComponentProps<typeof IonInput>['onIonChange'];
    minlength?: number | undefined;
    autocomplete?: AutocompleteTypes;
}> = ({ value, ariaLabel, onchange, minlength, autocomplete }) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const toggle = () => {
        setShowPassword(!showPassword);
    };

    return (
        <IonRow className="flex w-full">
            <IonCol>
                <IonInput
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    autocomplete={autocomplete}
                    value={value}
                    minlength={minlength}
                    onIonChange={onchange}
                    aria-label={ariaLabel || 'Mot de passe'}
                />
            </IonCol>
            <IonCol size="auto" className="align-middle">
                <IonIcon className="text-2xl h-full" icon={showPassword ? eyeOff : eye} onClick={toggle} />
            </IonCol>
        </IonRow>
    );
};

export default PasswordInput;
